(function () {
    'use strict';

    angular
        .module('app.core', [
            'ngAnimate', 'ngSanitize', 'ngAria',
            'blocks.auth',
            'blocks.exception', 
            'blocks.logger',
            'blocks.router',
            'blocks.notifications',
            'blocks.filters',
            'blocks.backendHubProxy',
            'blocks.directives',
            'ui.router', 'ngplus',
            'ui.bootstrap',
            'smart-table',
            'angularTrix'
            
            
        ]);
})();
